module.exports = __webpack_public_path__ + "static/media/Charmeleon_gaussian2.e2adba65.png";